import { useMutation, useQueryClient } from 'react-query';
import { Awaited } from 'ts-essentials';

import { bulkDeleteDrafts } from '@app/store/transport-layer/form/drafts';

export default function useDeleteDrafts() {
  const queryClient = useQueryClient();

  return useMutation<
    Awaited<ReturnType<typeof bulkDeleteDrafts>>,
    Error,
    Parameters<typeof bulkDeleteDrafts>
  >((vs) => bulkDeleteDrafts(...vs), {
    onSuccess: (_, [, { draftIds }]) => {
      draftIds.forEach((id) => {
        queryClient.invalidateQueries(['draft', id]);
      });
      queryClient.invalidateQueries('drafts');
    },
  });
}
